import { Button, Image, Spin } from 'antd';

import { CSS } from '@dnd-kit/utilities';
import { CloseCircleFilled } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useSortable } from '@dnd-kit/sortable';

export default function DraggerItems({ items = undefined, onRemove = undefined }) {
  const { attributes, listeners, setNodeRef, transform, transition, over, active } = useSortable({
    id: items?.uid,
  });

  const overTarget = over?.id === items?.uid && over?.id !== active.id;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    border: overTarget ? '2px solid #3f58ff' : 'unset',
    cursor: overTarget ? 'copy' : 'grab',
  };

  return (
    <SortableItemComponent ref={setNodeRef} enableHover={overTarget} style={style} {...attributes} {...listeners}>
      <Spin spinning={items?.status === 'uploading'}>
        <div style={{ border: '1px solid #000', borderRadius: 3, position: 'relative' }}>
          <ImageItemsContainer>
            <Image src={items?.url} alt="edc" preview={false} />
          </ImageItemsContainer>

          <Button
            type="text"
            onClick={() => onRemove?.()}
            icon={<CloseCircleFilled />}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              zIndex: 10,
            }}
          />
        </div>
      </Spin>
    </SortableItemComponent>
  );
}

const ImageItemsContainer = styled.div({
  width: 'auto',
  height: 135,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const SortableItemComponent = styled.div(({ enableHover }) => ({
  ':hover': {
    opacity: enableHover ? 0.4 : 1,
  },
}));
